// extracted by mini-css-extract-plugin
export default {"searchInputGroup":"SearchForm_searchInputGroup__VZt4i","input":"SearchForm_input__Ych8w","btn":"SearchForm_btn__OS7Qv"};